import { mapBrowserLanguageToSupported } from "./languageDetection";

/**
 * Keep the document language in sync with the language exposed by i18next.
 * This drives browser accessibility and translation tooling independently of
 * the static fallback in public/index.html.
 */
export function syncDocumentLanguage(language) {
	if (typeof document === "undefined" || !document.documentElement) return;

	document.documentElement.lang = mapBrowserLanguageToSupported(language);
}

/**
 * Bind document language updates to the relevant i18next lifecycle events.
 * @param {import("i18next").i18n} i18nInstance
 */
export function bindDocumentLanguage(i18nInstance) {
	const updateLanguage = (language) => {
		syncDocumentLanguage(
			language || i18nInstance.resolvedLanguage || i18nInstance.language
		);
	};
	const updateInitializedLanguage = () => updateLanguage();

	i18nInstance.on("initialized", updateInitializedLanguage);
	i18nInstance.on("languageChanged", updateLanguage);
	updateLanguage();

	return () => {
		i18nInstance.off("initialized", updateInitializedLanguage);
		i18nInstance.off("languageChanged", updateLanguage);
	};
}
